import React,{Component} from 'react';
import PropTypes from 'prop-types'
import personalIcon from '../../images/personal.svg';
import businessIcon from '../../images/bursiness.svg';

class Start extends Component{
    constructor(){
        super();
        this.onClickPersonal = this.onClickPersonal.bind(this);
        this.onClickBusiness = this.onClickBusiness.bind(this);

    }
    onClickPersonal(e){
        e.preventDefault();
        const {parent} = this.props;
        parent.setState({
            ...parent.state,
            page: 'SubdomainPlans',
            mode: 'Personal'
        });
    }

    onClickBusiness(e){
        e.preventDefault();
        const {parent} = this.props;
        parent.setState({
            ...parent.state,
            page: 'SubdomainPlans',
            mode: 'Business'
        });
    }
    render(){

        return(<div className={`SSL-Selector__Page SSL-Selector__Page--Start`}>
        <div className={`SSL-Selector__description clearfix`}>What type of website do you have?</div>
        <div className={`SSL-Selector__actions clearfix`}>
            <div className={`SSL-Selector__button`} onClick={this.onClickPersonal}>
                <img className={`button__icon`} src={personalIcon} alt={`Personal`} />
                <div className={`button__text`}>Personal</div>
            </div>
            <div className={`SSL-Selector__button`}  onClick={this.onClickBusiness}>
                <img className={`button__icon`} src={businessIcon} alt={`Business`} />
                <div className={`button__text`}>Business</div>
            </div>
            </div>
            <div className={`clear`}></div>
        </div>)
    }
}
Start.propTypes = {
    parent: PropTypes.object
}

export default Start;